export default __webpack_public_path__ + "static/media/logo2.296a361f.svg";